<template>
  <div class="mobile_container">
    <div class="mobile_recommend_box">
      <div class="mobile_recommend_list_title">
        相关推荐
      </div>
      <ul class="mobile_recommend_list">
        <li v-for="item in list" :key="item.id" class="mobile_recommend_item">
          <div v-if="item.img !== ''" class="mobile_recommend_item_left">
            <img :src="item.img" alt="图片">
          </div>
          <div
          :class="item.img === '' ? 'mobile_recommend_item_right mobile_recommend_item_left_none' : 'mobile_recommend_item_right'"
          >
            <p class="mobile_recommend_title">{{item.title}}</p>
            <dl class="mobile_recommend_info">
              <dt>
                <img :src="item.portrait" alt="头像">
                <span>{{item.user_name}}</span>
              </dt>
              <dd>
                {{item.add_time}}
              </dd>
            </dl>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style>
</style>
